(async () => {

    const { Core } = await importModule('Core');

    customElements.define('product-options-dropdown', class extends Core {

        elements = {
            dropdown: 'drop-down',
            current: '[data-current]',
            options: '*[data-option-value]'
        }

        render() {
            this._handleChange();
            this._handleOptionClicks();
            this._enableFirstOption();
        }

        _enableFirstOption() {
            const firstOption = this.$options?.[0];
            if (!firstOption) return
            firstOption.disabled = false;

            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.attributeName !== 'disabled' || !firstOption.disabled) return
                    // Bit more of a Just-In-Case solution, should be fixed by the
                    // disabling above
                    firstOption.disabled = false;
                    observer.disconnect();
                }
            });

            observer.observe(firstOption, {
                attributes: true
            });
        }

        _handleOptionClicks() {
            // Add direct click handler for options to work around dropdown limitations
            this.$options?.forEach(option => {
                option.addEventListener('click', (e) => {
                    const select = this.querySelector('select');
                    // If clicking the same value, just close the dropdown
                    if (select && option.value !== undefined) {
                        if (select.value === option.value) {
                            // Just close the dropdown without changing the value
                            this.$dropdown.close();
                        } else {
                            // Different value - update selection and let events flow
                            select.value = option.value;
                            select.dispatchEvent(new Event('change', {bubbles: true}));
                        }
                    }
                });
            });
        }

        _handleChange() {
            this.addEventListener('change', this._onChange.bind(this));
        }

        _onChange(e) {
            const search = window.location.search

            // Prevent camouflage from breaking things when we're using the
            // non-standard non-variant.
            if (!search.includes("variant")) {
                const stack = new Error().stack;
                const problemIDs = ["CamouflageVariants", "initCamouflage", "setupSelectors", "clickRadioLabel", "setInitialSelection", "triggerChangeEventOnSelect"];
                const wasCamouflage = stack && stack.split('\n').some(line =>
                    problemIDs.some(id => line.includes(id))
                );

                if (wasCamouflage) {
                    e.preventDefault()
                    e.stopPropagation()
                    const select = this.querySelector('select');
                    if (select) select.selectedIndex = 0;
                    return
                }
            }

            const newValue = e.target.value || window.none_label;
            this.$current.textContent = newValue
            this.$dropdown.close();
        }
    });

})();
